const TALK_ME_WIDGET_ID = 'd606d30a848faedc1ed2e2187838ab28';
const TALK_ME_API_METHOD = 'TalkMe';
const TALK_ME_SCRIPT_ID = 'supportScript';
const TALK_ME_SCRIPT_URL = 'https://lcab.talk-me.ru/support/support.js';
const TALK_ME_FALLBACK_SCRIPT_URL =
  'https://static.site-chat.me/support/support.int.js';
const TALK_ME_LOCAL_DOMAIN = 'app.agromon.ru';
const TALK_ME_RIGHT_OFFSET = 1;
const TALK_ME_BOTTOM_OFFSET = 1;
const TALK_ME_TRIGGER_ID = 'supportTrigger';
const TALK_ME_ROOT_CLASS = `online-chat-root-${TALK_ME_API_METHOD}`;
const TALK_ME_HIDE_STYLE_ID = 'talkMeHideTrigger';
const TALK_ME_TRIGGER_WAIT = 10000;
const TALK_ME_TRIGGER_RETRY = 100;
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '::1'];

const getWindow = () => (typeof window === 'undefined' ? null : window);
const getDocument = () => (typeof document === 'undefined' ? null : document);

const getTalkMeSetup = (win) => {
  const host = win.location?.hostname;

  if (LOCAL_HOSTS.includes(host)) {
    return {
      domain: TALK_ME_LOCAL_DOMAIN,
    };
  }

  return {};
};

const setupTalkMeQueue = () => {
  const win = getWindow();

  if (!win) return;

  win.supportAPIMethod = TALK_ME_API_METHOD;
  win[`${TALK_ME_API_METHOD}Setup`] = {
    ...(win[`${TALK_ME_API_METHOD}Setup`] || {}),
    ...getTalkMeSetup(win),
  };
  win[TALK_ME_API_METHOD] =
    win[TALK_ME_API_METHOD] ||
    function talkMeQueue(...args) {
      win[TALK_ME_API_METHOD].q = win[TALK_ME_API_METHOD].q || [];
      win[TALK_ME_API_METHOD].q.push(args);
    };
};

export const callTalkMe = (...args) => {
  const win = getWindow();
  const talkMe = win && win[TALK_ME_API_METHOD];

  if (typeof talkMe === 'function') {
    talkMe(...args);
  }
};

const appendTalkMeScript = (isFallback = false) => {
  const doc = getDocument();

  if (!doc) return;

  const script = doc.createElement('script');
  script.id = TALK_ME_SCRIPT_ID;
  script.async = true;
  script.src = `${
    isFallback ? TALK_ME_FALLBACK_SCRIPT_URL : TALK_ME_SCRIPT_URL
  }?h=${TALK_ME_WIDGET_ID}`;
  script.onerror = isFallback ? undefined : () => appendTalkMeScript(true);

  (doc.head || doc.body).appendChild(script);
};

const hideTalkMeTrigger = () => {
  const doc = getDocument();

  if (!doc || doc.getElementById(TALK_ME_HIDE_STYLE_ID)) return;

  const style = doc.createElement('style');
  style.id = TALK_ME_HIDE_STYLE_ID;
  // не display: none — виджет считает позицию окна чата по координатам иконки,
  // а сама иконка перерисовывается каждый раз при закрытии чата
  style.textContent = `#${TALK_ME_TRIGGER_ID}{opacity:0!important;pointer-events:none!important;}`;

  (doc.head || doc.body).appendChild(style);
};

// иконка появляется в DOM только после загрузки виджета и только пока чат
// закрыт, поэтому ждём её, но не открываем чат повторно, если он уже открыт
const clickTalkMeTrigger = (startedAt = Date.now()) => {
  const doc = getDocument();

  if (!doc) return;

  const trigger = doc.getElementById(TALK_ME_TRIGGER_ID);

  if (trigger) {
    trigger.click();
    return;
  }

  const isWidgetReady = !!doc.querySelector(`.${TALK_ME_ROOT_CLASS}`);

  if (isWidgetReady || Date.now() - startedAt > TALK_ME_TRIGGER_WAIT) return;

  setTimeout(() => clickTalkMeTrigger(startedAt), TALK_ME_TRIGGER_RETRY);
};

export const initTalkMe = () => {
  const doc = getDocument();

  if (!doc || doc.getElementById(TALK_ME_SCRIPT_ID)) return;

  setupTalkMeQueue();
  hideTalkMeTrigger();
  callTalkMe('hideTrigger');
  appendTalkMeScript();
};

export const openTalkMeSupport = () => {
  callTalkMe('openSupport');
  clickTalkMeTrigger();
  callTalkMe('setPosition', -TALK_ME_RIGHT_OFFSET, -TALK_ME_BOTTOM_OFFSET);
  setTimeout(() => {
    callTalkMe('setPosition', -TALK_ME_RIGHT_OFFSET, -TALK_ME_BOTTOM_OFFSET);
  }, 300);
};

export const setTalkMeClientInfo = (user) => {
  callTalkMe('setClientInfo', {
    name: `${user?.last_name || ''} ${user?.first_name || ''}`.trim(),
    email: user?.email || '',
  });
};
